import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1 pt-16 flex flex-col items-center justify-center text-center px-4 py-16">
        <p className="text-7xl md:text-9xl font-black text-primary-100 select-none">404</p>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-950 mt-4 mb-2">这个页面找不到啦</h1>
        <p className="text-sm text-foreground-500 mb-8">页面可能已下线或地址有误，去看看其他精彩内容吧</p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mb-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-5-line"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-full border border-primary-300 text-primary-600 hover:bg-primary-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-line"></i>
            去搜索内容
          </Link>
        </div>
        <div className="flex flex-wrap justify-center gap-2 max-w-lg">
          {categories.map((c) => (
            <Link
              key={c.key}
              to={`/category/${c.key}`}
              className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium cursor-pointer hover:bg-secondary-200 transition-colors flex items-center gap-1"
            >
              <i className={`${c.icon} text-sm`}></i>
              {c.name}
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}